window.addEventListener('load', function() {  
  
    var _learnq = window._learnq || [];    
    var klAjax = true;
    console.log('initialize ',klAjax);

    var collectionList = "" || 'under development';
    var buttons = document.querySelectorAll("button, .rebuy-button");
    buttons.forEach(button => {
      button.addEventListener('click', function(e){
        //console.log(e.target.getAttribute('data-collections'));
        //console.log('button clicked: ',e.target);
        if(e.target.getAttribute('data-collections')){
          collectionList = e.target.getAttribute('data-collections');
        }      
      });
    });
    document.addEventListener('rebuy:cart.add', (event) => {
      setTimeout(function(){
/*
        console.log('event: ', event.detail);
        console.log('event widget id: ', event.detail.item['properties']['_widget_id']);*/
/*
        Rebuy.widgets.forEach(function(widget,j){
          if(widget.id == event.detail.item['properties']['_widget_id']){
            console.log(widget.data.products);
            console.log('widget id '+ widget.id, 'item added id '+event.detail.item['product_id']);
            let prds = widget.data.products;
            console.log(prds);
          }
        });*/

        const Cart = window.Rebuy.Cart;
        var itemList = [];
        Cart.items().forEach(function(item,i){
          var itemObj = new Object();
            itemObj.variant_id = item['variant_id'];
            itemObj.sku = item['sku'];
            itemObj.title = item['product_title'];
            itemObj.quantity = item['quantity'];
            itemObj.price = item['price'] / 100;
            itemObj.RowTotal = item['line_price'] / 100;
            itemObj.url = 'https://teeccino.com' + item['url'];
            itemObj.image = item['featured_image']['url'];
            itemList.push(itemObj);
        });
        console.log('from cart.items: ',itemList);

        if (klAjax) {
          _learnq.push(['track', 'Added to Cart', {
            "ProductID" : event.detail.item['product_id'],
            "Quantity" : event.detail.item['quantity'],
            "Price" : event.detail.item['price'] / 100,
            "URL" : event.detail.item['url'],
            "ImageURL" : event.detail.item['image'],
            "Name" : event.detail.item['title'],
            "Categories" : collectionList,
            "Source" : "Custom Script",
            "items": itemList
          }]);
          klAjax = false;
          console.log('de-initialize',klAjax);          
          collectionList = "";          
        }
        console.log('timeout active 1');
      }, 2000);      
      if(!klAjax){
        klAjax = true;
        console.log('re-initialize',klAjax);
      }      
    });    
  
  console.log('timeout active 2');
});